import throttle from 'lodash/throttle';
// import set from 'alpinejs';

require('waypoints/lib/noframework.waypoints.js');
// require('waypoints/lib/shortcuts/inview.js');


$(function () {
    let oldScroll = $(window).scrollTop();
    let didScroll = false;
    let prevScrollpos = window.pageYOffset;

    /* scroll event to hide display top bar nav*/
    function scrollCallback() {
        $('.locale-dropdown').removeClass('open');
        const $navbar = $('#sticky-header');
        const currentScrollPos = window.pageYOffset;
        if (currentScrollPos > 80) {
            if (prevScrollpos >= currentScrollPos) {
                $navbar.addClass("reveal");
            } else {
                $navbar.removeClass("reveal");
            }
        } else if (currentScrollPos <= 80) {
            setTimeout(function () {
                $navbar.removeClass("reveal");
            }, 150);
        }
        prevScrollpos = currentScrollPos;
    }

    $(window).on('scroll', _.throttle(scrollCallback, 200, {leading: true}));

    /* create item chapter tracker */
    let index = 1;
    let waypointData = [];
    $('.chapter, .page-hero').each(function () {
        const $this = $(this);
        $this.attr('data-index', index);
        waypointData.push({
            index: $this.attr('data-index'),
            slug : $this.attr('data-slug'),
            title: $this.attr('data-title'),
            el   : $this[0],
        })

        // const inview = new Waypoint.Inview({
        //     element: $this[0],
        //     enter  : function (direction) {
        //         console.log(direction + ' - ' + $this.attr('data-title'));
        //         // console.log($this.attr('data-title'));
        //         $chapterTracker.find('.title').text($this.attr('data-title'));
        //         $chapterTracker.find('.number .current').text($this.attr('data-index'));
        //         history.pushState(null, null, $this.attr('data-slug'));
        //         updateShareLink();
        //         /* change nav state */
        //         $(`#fullscreen-nav .chapter-item`).removeClass('current');
        //         $(`#fullscreen-nav .chapter-item[href="${$this.attr('data-slug')}"]`).addClass('current');
        //
        //         /* change background */
        //         $('#fullscreen-nav .bg-img .img').removeClass('current');
        //         $('#fullscreen-nav .bg-img .img[data-index="' + $this.attr('data-index') + '"]').addClass('current');
        //
        //         $('#fullscreen-nav .nav-img .img').removeClass('current');
        //         $('#fullscreen-nav .nav-img .img[data-index="' + $this.attr('data-index') + '"]').addClass('current');
        //     },
        // });
        index++;
    });
    $('.chapter-tracker .number .total').text($('.chapter, .page-hero').length);

    var waypointTimer;
    waypointData.forEach(function (data, index) {
        const $chapterTracker = $('.chapter-tracker');
        const waypoint = new Waypoint({
            element: data.el,
            handler: function (direction) {
                let newData;
                if (direction === 'down') {
                    newData = Object.assign({}, data);
                } else if (direction === 'up') {
                    newData = Object.assign({}, waypointData[index - 1]);
                }
                window.clearTimeout(waypointTimer);
                waypointTimer = setTimeout(function () {
                    $chapterTracker.find('.title').text(newData.title);
                    $chapterTracker.find('.number .current').text(newData.index);

                    history.pushState(null, null, newData.slug);
                    console.log(newData.slug);
                    updateShareLink();
                    //
                    /* change nav state */
                    $(`#fullscreen-nav .chapter-item`).removeClass('current');
                    $(`#fullscreen-nav .chapter-item[href="${newData.slug}"]`).addClass('current');

                    /* change background */
                    $('#fullscreen-nav .bg-img .img').removeClass('current');
                    $(`#fullscreen-nav .bg-img .img[data-index="${newData.index}"]`).addClass('current');

                    $('#fullscreen-nav .nav-img .img').removeClass('current');
                    $(`#fullscreen-nav .nav-img .img[data-index="${newData.index}"]`).addClass('current');

                }, 500)
            },
            offset : '50%',
        })
    });

    let isNavLoaded = 0;

    /* load nav content process */
    function loadNavContent() {
        if (isNavLoaded) {
            return false;
        } else {
            isNavLoaded = 1;
            $('.chapter, .page-hero').each(function () {
                const $this = $(this);
                const $chapterTracker = $('.chapter-tracker');
                const $nav = $('#fullscreen-nav .chapter-nav');
                const $bg = $('#fullscreen-nav .bg-img');
                const $navImg = $('#fullscreen-nav .nav-img');

                /* bg image*/
                const bgImgSrc = $this.attr('data-navigation-image');
                // console.log(bgImgSrc);
                $bg.append(
                    `<div class="img" data-index="${$this.attr('data-index')}" style="background-image: url(${bgImgSrc})"></div>`
                )

                /* other left img*/
                const leftImgSrc = $this.attr('data-hero-image');
                const leftImgType = $this.attr('data-hero-image-type');
                const leftImgMime = $this.attr('data-hero-image-mime');

                if (leftImgType === 'video') {
                    $navImg.append(
                        `<div class="img" data-index="${$this.attr('data-index')}">
                    <video class="img-fluid w-100" loop muted autoplay playsinline preload="none">
                        <source src="${leftImgSrc}" type="${leftImgMime}">
                    </video>
                </div>`
                    );
                } else {
                    $navImg.append(
                        `<div class="img" data-index="${$this.attr('data-index')}">
                    <img class="img-fluid w-100" src="${leftImgSrc}"/>
                </div>`
                    )
                }

                /* add item to chapter nav */
                $nav.append(`
                <a class="chapter-item" data-index="${$this.attr('data-index')}" href="${$this.attr('data-slug')}" 
                data-navigation-image="${$this.attr('data-navigation-image')}">
                    <div class="number-container">
                        <div class="number">
                            <div class="current">${$this.attr('data-index')}</div>
                            <div class="separator"></div>
                            <div class="total"></div>
                        </div>
                    </div>
                    <div class="content">
                        <h4 class="title">
                            ${$this.attr('data-title')}
                        </h4>
                        <div class="subtitle">${$this.attr('data-subtitle')}</div>
                    </div>
                </a>
            `);
            });
            $('#fullscreen-nav .chapter-nav .chapter-item .number .total').text($('.chapter, .page-hero').length);

            // console.log(location.hash);
            const initialIndex = $(location.hash).attr('data-index');

            /* change nav state */
            $(`#fullscreen-nav .chapter-item`).removeClass('current');
            $(`#fullscreen-nav .chapter-item[href="${location.hash}"]`).addClass('current');

            /* change background */
            $('#fullscreen-nav .bg-img .img').removeClass('current');
            $(`#fullscreen-nav .bg-img .img[data-index="${initialIndex}"]`).addClass('current');

            $('#fullscreen-nav .nav-img .img').removeClass('current');
            $(`#fullscreen-nav .nav-img .img[data-index="${initialIndex}"]`).addClass('current');
        }
    }

    /* on hover nav chapter item */
    $(document).on('mouseenter', '#fullscreen-nav .chapter-item', function () {
        const index = $(this).attr('data-index');
        $('#fullscreen-nav .bg-img .img[data-index="' + index + '"]').addClass('hover');
        $('#fullscreen-nav .nav-img .img.main').css('opacity', '0');
        $('#fullscreen-nav .nav-img .img[data-index="' + index + '"]').addClass('hover');
    });
    /* on hover out nav chapter item */
    $(document).on('mouseleave', '#fullscreen-nav .chapter-item', function () {
        const index = $(this).attr('data-index');
        $('#fullscreen-nav .bg-img .img[data-index="' + index + '"]').removeClass('hover');
        $('#fullscreen-nav .nav-img .img.main').css('opacity', '1');
        $('#fullscreen-nav .nav-img .img[data-index="' + index + '"]').removeClass('hover');
    });

    /* update share link on share-button */
    function updateShareLink() {
        /* change share button url */
        // https://www.facebook.com/sharer/sharer.php?u=
        // https://twitter.com/intent/tweet?url=
        // https://www.linkedin.com/sharing/share-offsite/?url=
        const placeholderText = $('meta[name=share-placeholder-text]').prop('content');
        $('#share-button-container a').each(function () {
            let linkTemplate = '';
            if ($(this).hasClass('facebook')) {
                linkTemplate = 'https://www.facebook.com/sharer/sharer.php?u=';
            } else if ($(this).hasClass('twitter')) {
                linkTemplate = 'https://twitter.com/intent/tweet?text=' + placeholderText + '&url=';
            } else if ($(this).hasClass('linkedin')) {
                linkTemplate = 'https://www.linkedin.com/sharing/share-offsite/?url=';
            }
            $(this).attr('href', linkTemplate + '' + encodeURIComponent(window.location.href));
        })
    }

    /* toggle open/close nav menu on burger menu */
    $('#menu-toggler-button, .menu-toggler-button, .chapter-tracker').click(function () {
        loadNavContent();
        $('#fullscreen-nav').toggleClass('open');
        setTimeout(function () {
            $('body').toggleClass('menu-open');
        }, 400);
    });

    /* toggle open/close nav menu on chapter tracker */
    $(document).on('click', '#fullscreen-nav .chapter-item, #menu-close-button', function () {
        $('#fullscreen-nav').removeClass('open');
        $('body').removeClass('menu-open');
    });

    /* toggle display share button*/
    $('#share-button-toggler').click(function () {
        $(this).parent('.share-container').focus();
    });

    $('.locales a').click(function(e){
        e.preventDefault();
        let href = $(this).attr('href');
        href += location.hash;
        window.location = href;
    })

    $('.locale-dropdown .dropdown-toggle').click(function(e){
        const parent = $(this).parent('.locale-dropdown');
        $(this).parent('.locale-dropdown').toggleClass('open');
        // parent.find('.dropdown-menu').toggleClass('show');
    });
})

